export default ({ $integrationsManager, $lux }) => {
    $integrationsManager.loaders.onNuxtReadyLoader(() => {
        if (!performance || !performance.measure) return
        performance.measure('NUXT_LOADING')
    })

    $integrationsManager.onReady((integrations) => {
        const $geolocation = integrations.geolocation
        if (!$geolocation.enabled) return
        const west = ['WA', 'OR', 'ID', 'MT', 'WY', 'CA', 'NV', 'UT', 'CO']
        const southWest = ['AZ', 'NM', 'TX', 'OK']
        const midWest = ['ND', 'MN', 'WI', 'MI', 'SD', 'IA', 'IL', 'IN', 'OH', 'NE', 'KS', 'MO']
        const southEast = [
            'AR',
            'LA',
            'MS',
            'KY',
            'TN',
            'AL',
            'FL',
            'GA',
            'SC',
            'NC',
            'VA',
            'WV',
            'DC',
        ]
        const northEast = ['MD', 'PA', 'DE', 'NJ', 'NY', 'CT', 'RI', 'MA', 'VT', 'NH', 'ME']

        const region = $geolocation.state.region
        if (west.includes(region)) $lux.addData('Region', 'West')
        else if (southWest.includes(region)) $lux.addData('Region', 'Southwest')
        else if (midWest.includes(region)) $lux.addData('Region', 'Midwest')
        else if (southEast.includes(region)) $lux.addData('Region', 'Southeast')
        else if (northEast.includes(region)) $lux.addData('Region', 'Northeast')
    })
}
